import { request } from '../../services/RestClient';
import ServiceUrl from '../../utils/ServiceUrl';

export default class GeoLocatorService {
  static getUserLocation() {
    return request({
      method: 'get',
      url: `${ServiceUrl.public('geolocator')}/v1/`,
    });
  }
}
